import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod} from '@/core/Types/IRepository';

// TODO: Cambiar a un modelo

class AuthServices extends BaseRepository {
  public collection = 'auth';
  public version = 'v1';

  public getPermissions(params: GenericMethod) {
    return this.request({...params, url: 'get_permission', version: 'v2'});
  }

  public async resetPassword(params: GenericMethod) {
    return await this.request({...params, url: 'reset_password'});
  }

  public async logout(params: GenericMethod) {
    return await this.request({...params, url: 'logout', method: 'POST'});
  }

  public async login(params: string, toast: any) {
    const login = await this.request({method: 'post', url: 'login', query: params});
    if (login.token) {
      return login;
    } else {
      toast.error(login.response.message.name[0]);
    }
    return {complete: false};
  }

  public overrideUser(params: GenericMethod) {
    return this.request({...params, url: 'check_user_auth'});
  }

  public removeUserOverride(params: GenericMethod) {
    return this.request({...params, url: 'remove_user_auth'});
  }

    public async checkUser(params: GenericMethod) {
        return await this.request({url:"check_user_auth",query:params, method: "POST"});
    }
}

export default new AuthServices(axiosInstance);
